import React, { useState, useEffect } from "react";
import { useUserStore } from "../../../store/userStore.js";


import EditProfileBoxLabel from "../../../components/label/editprofileboxlabel";
import EditProfileDropdown from "../../../components/dropdown/editprofiledropdown";
import EditProfileMultipleSelect from "../../../components/dropdown/editprofilemultipleselection";
import PrimaryButton from "../../../components/button/primarybutton";
import ErrorText from "../../../components/errortext/errortext";
import Loader from "../../../components/loader/loader";
import Spacer from "../../../components/spacer/spacer";

import {
  beard,
  bloodGroup,
  bodyType,
  complexion,
  foodHabit,
  hairColor,
  hairLength,
  hairType,
  healthCondition,
  heightList,
  hijab,
  smoking,
  waliItems,
} from "../../../utils/arrayitems";

import images from "../../../assets";

import TabHeading from "./tabheading";
import "./styles.css";

const PhyscialLifestyle = () => {
  const { user, isUserLoading, getUser, updateUser } = useUserStore();

  const [state, setState] = useState({
    height: "",
    hairColor: "",
    hairType: "",
    hairLength: "",
    complexion: "",
    bloodGroup: "",
    bodyType: "",
    healthCondition: "",
    beard: "",
    hijab: "",
    wali: "",
    foodHabit: [],
    smoking: "",
  });
  const [error, setError] = useState({
    height: "",
    healthCondition: "",
    beard: "",
    wali: "",
    hijab: "",
  });

  useEffect(() => {
    setState({
      ...state,
      height: user?.height ?? "",
      hairColor: user?.hairColor ?? "",
      hairType: user?.hairType ?? "",
      hairLength: user?.hairLength ?? "",
      complexion: user?.complexion ?? "",
      bloodGroup: user?.bloodGroup ?? "",
      bodyType: user?.bodyType ?? "",
      physicalStatus: user?.physicalStatus ?? "",
      beard: user?.beard ?? "",
      hijab: user?.hijab ?? "",
      wali: user?.wali ?? "",
      foodHabit: user?.foodHabit ?? "",
      smoking: user?.smoking ?? "",
    });
  }, [isUserLoading]);

  const getprofileData = () => {
    const payload = { username: user?.username };
    getUser(payload);
  };

  const handleSubmit = () => {
    if (!state?.height) {
      setError({
        ...error,
        height: "height cannot be empty",
      });
    } else if (!state?.physicalStatus) {
      setError({
        ...error,
        physicalStatus: "Health condition cannot be empty",
      });
    } else if (user?.gender?.toLowerCase() === "male" && !state?.beard) {
      setError({
        ...error,
        beard: "Beard cannot be empty",
      });
    } else if (user?.gender?.toLowerCase() === "female" && !state?.wali) {
      setError({
        ...error,
        wali: "Wali cannot be empty",
      });
    } else if (user?.gender?.toLowerCase() === "female" && !state?.hijab) {
      setError({
        ...error,
        hijab: "Hijab cannot be empty",
      });
    } else {
      const payload = { username: user?.username, data: state };
      updateUser(payload, () => {
        getprofileData();
      });
    }
  };
  return (
    <>
      <TabHeading
        image={images.editProfilePhysicalLifestyle}
        title="Physical Appearance & Lifestyle"
        subtitle="Complete to easily find your ideal partner!"
      />
      <div className="edit-profile-content">
        {isUserLoading ? (
          <Loader />
        ) : (
          <>
            {/* height */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Height" required={true} />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={heightList}
              onChange={(e) => {
                setState({ ...state, height: e });
                setError({ ...error, height: "" });
              }}
              value={state.height || undefined}
            />
            {error?.height && <ErrorText text={error?.height} />}
            <Spacer height="12px" />

            {/* hair color */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Hair Color" />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={hairColor}
              onChange={(e) => setState({ ...state, hairColor: e })}
              value={state.hairColor || undefined}
            />

            <Spacer height="12px" />

            {/* Hair Type */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Hair Type" />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={hairType}
              onChange={(e) => setState({ ...state, hairType: e })}
              value={state.hairType || undefined}
            />

            <Spacer height="12px" />

            {/* Hair Length */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Hair Length" />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={hairLength}
              onChange={(e) => setState({ ...state, hairLength: e })}
              value={state.hairLength || undefined}
            />

            <Spacer height="12px" />

            {/* Complexion */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Complexion" />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={complexion}
              onChange={(e) => setState({ ...state, complexion: e })}
              value={state.complexion || undefined}
            />

            <Spacer height="12px" />

            {/* Blood Group */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Blood Group" />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={bloodGroup}
              onChange={(e) => setState({ ...state, bloodGroup: e })}
              value={state.bloodGroup || undefined}
            />

            <Spacer height="12px" />

            {/* Body Type */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Body Type" />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={bodyType}
              onChange={(e) => setState({ ...state, bodyType: e })}
              value={state.bodyType || undefined}
            />

            <Spacer height="12px" />

            {/* Health Condition */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Health Condition" required={true} />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={healthCondition}
              onChange={(e) => {
                setState({ ...state, physicalStatus: e });
                setError({ ...error, physicalStatus: "" });
              }}
              value={state.physicalStatus || undefined}
            />
            {error?.physicalStatus && (
              <ErrorText text={error?.physicalStatus} />
            )}

            <Spacer height="12px" />

            {/* Beard or hijab*/}
            {user?.gender?.toLowerCase() === "male" ? (
              <>
                <div className="edit-profile-label-container">
                  <EditProfileBoxLabel label="Beard" required={true} />
                </div>
                <Spacer height="8px" />
                <EditProfileDropdown
                  placeholder="Please select"
                  data={beard}
                  onChange={(e) => {
                    setState({ ...state, beard: e });
                    setError({ ...error, beard: "" });
                  }}
                  value={state.beard || undefined}
                />
                {error?.beard && <ErrorText text={error?.beard} />}
              </>
            ) : (
              <>
                <div className="edit-profile-label-container">
                  <EditProfileBoxLabel label="Hijab" required={true} />
                </div>
                <Spacer height="8px" />
                <EditProfileDropdown
                  placeholder="Please select"
                  data={hijab}
                  onChange={(e) => {
                    setState({ ...state, hijab: e });
                    setError({ ...error, hijab: "" });
                  }}
                  value={state.hijab || undefined}
                />
                {error?.hijab && <ErrorText text={error?.hijab} />}
              </>
            )}

            <Spacer height="12px" />
            {/* wali */}
            {user?.gender?.toLowerCase() === "female" && (
              <>
                <div className="edit-profile-label-container">
                  <EditProfileBoxLabel label="Wali" required={true} />
                </div>
                <Spacer height="8px" />
                <EditProfileDropdown
                  placeholder="Please select"
                  data={waliItems}
                  onChange={(e) => {
                    setState({ ...state, wali: e });
                    setError({ ...error, wali: "" });
                  }}
                  value={state.wali || undefined}
                />
                {error?.wali && <ErrorText text={error?.wali} />}
                <Spacer height="12px" />
              </>
            )}

            {/* Food Habit */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Food Habit" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="Please select"
              data={foodHabit}
              onChange={(e) => setState({ ...state, foodHabit: e })}
              value={state.foodHabit || undefined}
            />

            <Spacer height="12px" />

            {/* Smoking */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Smoking" />
            </div>
            <Spacer height="8px" />
            <EditProfileDropdown
              placeholder="Please select"
              data={smoking}
              onChange={(e) => setState({ ...state, smoking: e })}
              value={state.smoking || undefined}
            />
          </>
        )}
        <Spacer height="32px" />
        <PrimaryButton
          text="Save & Continue"
          onClick={handleSubmit}
          disabled={isUserLoading}
        />
      </div>
    </>
  );
};

export default PhyscialLifestyle;








